// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import VueMoment from 'vue-moment';
import moment from "moment-timezone";
import Multiselect from 'vue-multiselect';
import SegmentedControl from 'vue-segmented-control';
import carousel from 'vue-owl-carousel';
import Popover from 'vue-js-popover';
import SyncLoader from 'vue-spinner/src/SyncLoader';
import RangeSlider from 'vue-range-slider';
import 'vue-range-slider/dist/vue-range-slider.css';
import VueGtag from "vue-gtag";
import VueIntro from 'vue-introjs';
import 'intro.js/introjs.css';
import Gravatar from 'vue-gravatar';
import VueCarousel from 'vue-carousel';
import checkbox from 'vue-material-checkbox';
import VueResizeText from 'vue-resize-text';
import TextareaAutosize from 'vue-textarea-autosize';
import '@/plugins/fontawesome';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import '@/components/shared/emojiFilter';
import i18n from '@/lang/lang';
import store from '@/store';
import EventBus from '@/components/shared/eventbus';
import VueTour from 'vue-tour';
import App from './App';
import router from './router';

require('vue2-animate/dist/vue2-animate.min.css');


Vue.use(TextareaAutosize);
Vue.use(VueResizeText);
Vue.use(VueTour);
Vue.use(VueMoment, {
  moment,
});


Vue.component('number-input', VueNumberInput);
Vue.use('vue-carousel', VueCarousel);
Vue.component('v-gravatar', Gravatar);
Vue.use(VueGtag, {
  config: { id: 'UA-51469332-11' },
  pageTrackerScreenviewEnabled: true,
  pageTrackerTemplate(to) {
    return {
      page_title: to.name,
      page_path: to.path,
    };
  },
}, router);

// register globally
Vue.component('multiselect', Multiselect);
Vue.component('segmented-control', SegmentedControl);
Vue.component('carousel', carousel);
Vue.component('loader', SyncLoader);
Vue.component('range-slider', RangeSlider);
Vue.use(Popover);
Vue.component('checkbox', checkbox);

Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY HH:mm');
  }
  return '';
});

Vue.use(VueSweetalert2, {
  confirmButtonColor: '#4B56A9',
  cancelButtonColor: '#E32A2A',
});

Vue.prototype.$eventBus = EventBus;

Vue.config.productionTip = false;
Vue.use(VueIntro);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  render: h => h(App),
}).$mount('#app');
